<template>
  <div class="border-0">
    <McEditableTable
      v-show="isTableDataAvailable"
      ref="table"
      searchable
      hasEmit:submitError
      :fields="fields"
      editStartFocusKey="duration"
      :apiClient="apiClient"
      :hasBulkDelete="true"
      :apiErrorMappings="bufferTimeApiErrorMappings"
      @available-change="handleDataAvailable"
      @submitError="handleSubmitError"
    >
      <template #duration="{ value }">
        {{ formatISODuration(value) }}
      </template>
    </McEditableTable>
    <div v-show="!isTableDataAvailable" class="empty-table-container">
      <img :src="illustrationPath" alt />
      <strong>{{ $t('setting.bufferTime.emptyState.empty') }}</strong>
      <p>{{ $t('setting.bufferTime.emptyState.add') }}</p>
      <b-button variant="primary" @click="handleAdd">
        <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import McEditableTable from '@/components/McEditableTable'
import McChipList from '@/components/McChipList'

import { Helper } from '@/mixin/helper'
import bufferTimeFields from './lib/fields/bufferTimeFields'
import bufferTimeApiErrorMappings from './lib/constants/buffer-time-api-error-mappings'

import * as BufferTime from '@/services/rest-api/lib/fleet-task/buffer-time'

export default {
  components: {
    McEditableTable,
    McChipList,
  },
  mixins: [Helper],
  data() {
    return {
      isTableDataAvailable: true,
      bufferTimeApiErrorMappings: bufferTimeApiErrorMappings,
    }
  },
  computed: {
    fields() {
      return bufferTimeFields
    },
    apiClient() {
      return {
        get: BufferTime.get,
        store: BufferTime.store,
        show: BufferTime.show,
        update: BufferTime.update,
        delete: BufferTime.bulkDelete,
      }
    },
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-data.svg`)
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleAdd() {
      this.$refs.table.handleAdd()
    },
    handleSubmitError(data) {
      if (data.status !== 400) return

      const issues = data?.errors_v2?.issues || []
      const matchedIssue = issues.find((issue) => this.bufferTimeApiErrorMappings?.issueCode?.[issue?.code])
      const issueTranslationKey = matchedIssue
        ? this.bufferTimeApiErrorMappings.issueCode[matchedIssue.code]
        : null

      if (issueTranslationKey) {
        this.$mcToast.error(this.$t(issueTranslationKey))
        return
      }

      this.$mcToast.error(this.$t('global.inputFormatError'))
    },
  },
}
</script>
